/* @jsx mdx */
  import React from 'react'
  import { mdx } from '@mdx-js/react'
  /* @jsx mdx */
import { Playground, Props } from 'docz'
import Byline from '.'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "byline"
    }}>{`Byline`}</h1>
    <p>{`Every story needs an author and a byline.`}</p>
    <Props of={Byline} mdxType="Props" />
    <Playground __position={1} __code={'<Byline authors=\"Tanner Walters\" />\n<Byline authors={[\'Tanner Walters\', \'Mackenzie Possee\', \'Jacob Preal\']} />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Byline
    }} mdxType="Playground">
  <Byline authors="Tanner Walters" mdxType="Byline" />
  <Byline authors={['Tanner Walters', 'Mackenzie Possee', 'Jacob Preal']} mdxType="Byline" />
    </Playground>
    </MDXLayout>;
}

MDXContent.isMDXComponent = true;
  